export enum GcpCompetitiveTrackingEnum {
  NO = 'No',
  YES_GCP = 'Yes, GCP',
  YES_PREMISE = 'Yes, On Premise',
  YES_OTHER = 'Yes, Other Cloud Service Provider',
}
